import i18n from 'translations/i18n';
import { secondsToMilliseconds } from 'date-fns';

export const ENV_OPS_EMAIL = '@bigleaf.net';

export const BASE_SITE_ROUTE_PATH = '/site/:siteId/:group';
export const SITE_ROUTE_PATH = `${BASE_SITE_ROUTE_PATH}/:page?/:subpage?/:detail?`;
export const COMPANY_ROUTE_PATH = '/companies/:companyId/:page/:subpage?/*';
export const LOGS_ROUTE_PATH = '/:tab/:page';

export const MAX_EMAIL_LENGTH = 254;
export const MAX_USERNAME_LENGTH = 32;

export const USERNAME_REGEX = /^[A-Za-z0-9_+.!#$'^`~@-]+$/;
export const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/;
export const EMAIL_REGEX =
    /^(?!.*\.\.)([a-z0-9][a-z0-9._%+-]{0,62}[a-z0-9])@([a-z0-9.-]+\.[a-z]{2,})$/i;

const IPV4_PATTERN = '((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)\\.?\\b){4}';
export const IPV4_REGEX = new RegExp(`^${IPV4_PATTERN}$`);
export const CIDR_REGEX = new RegExp(
    `^${IPV4_PATTERN}\\/(3[0-2]|[12]\\d|\\d)$`
);

export const ALARM_LEVELS_GRAPH_METRICS = [
    'downlink-alarm-level',
    'uplink-alarm-level',
];

export const TIME_UNITS = {
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
};

export const EMAIL_RULES = {
    required: {
        value: true,
        message: i18n.t('common:fields.email.required'),
    },
    pattern: {
        value: EMAIL_REGEX,
        message: i18n.t('common:fields.email.invalid'),
    },
    maxLength: {
        value: MAX_EMAIL_LENGTH,
        message: i18n.t('common:fields.email.max_length'),
    },
};

export const USERNAME_RULES = {
    required: {
        value: true,
        message: i18n.t('common:fields.username.required'),
    },
    maxLength: {
        value: MAX_USERNAME_LENGTH,
        message: i18n.t('common:fields.username.max_length'),
    },
    validate: (username: string) => {
        if (!USERNAME_REGEX.test(username)) {
            return i18n.t('common:fields.username.invalid');
        }
    },
};

export const GRAPH_LAG_OFFSET = secondsToMilliseconds(30);
